import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'

export const CATEGORY_SLIDES_COUNT: Record<OnboardingCategoriesEnum, number> = {
  [OnboardingCategoriesEnum.whereToStart]: 4,
  [OnboardingCategoriesEnum.candidatesInProject]: 7,
  [OnboardingCategoriesEnum.actionsWithCandidates]: 6,
  [OnboardingCategoriesEnum.funnel]: 4,
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: 6,
  [OnboardingCategoriesEnum.userRights]: 3
}
